import * as z from "zod";

import { RawDateTimeSchema } from "@shared/schemas/date";

import { CustomerSchema } from "./customer.schema";
import { ReceiverSchema } from "./receiver.schema";
import { EstablishmentSchema } from "./establishment.schema";
import { PaymentRuleSchema } from "./payment-rule.schema";
import { ProductSchema } from "./product.schema";
import { TransactionStatusSchema } from "./transaction-status.schema";
import { PaymentAttemptSchema } from "./payment-attempt.schema";

export const TransactionSchema = z.object({
  Id: z.guid(),
  Establishment: EstablishmentSchema.nullable(),
  Identifier: z.string(),
  Description: z.string(),
  Customer: CustomerSchema,
  Receiver: ReceiverSchema.nullable(),
  TotalAmount: z.int(),
  Products: z.array(ProductSchema),
  PaymentRules: z.array(PaymentRuleSchema),
  SuccessfulPaymentAttempt: PaymentAttemptSchema.nullable(),
  CurrentPaymentAttempt: PaymentAttemptSchema.nullable(),
  Status: TransactionStatusSchema,
  ExpireAt: RawDateTimeSchema.nullable(),
  CanceledAt: RawDateTimeSchema.nullable(),
  CompletedAt: RawDateTimeSchema.nullable(),
  CreatedAt: RawDateTimeSchema,
});
